import React from 'react';

const CalendarIcon = ({ width = 20, height = 20, color = '#424242', ...rest }) => {
  return (
    <svg {...rest} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
      <path
        d="M5.63419 5.03233V2.625M10.4489 5.03233V2.625M5.03235 7.43966H11.0507M3.82868 13.458H12.2544C12.5736 13.458 12.8798 13.3312 13.1055 13.1054C13.3313 12.8797 13.4581 12.5736 13.4581 12.2543V5.03233C13.4581 4.7131 13.3313 4.40694 13.1055 4.18121C12.8798 3.95548 12.5736 3.82867 12.2544 3.82867H3.82868C3.50944 3.82867 3.20328 3.95548 2.97755 4.18121C2.75182 4.40694 2.625 4.7131 2.625 5.03233V12.2543C2.625 12.5736 2.75182 12.8797 2.97755 13.1054C3.20328 13.3312 3.50944 13.458 3.82868 13.458Z"
        stroke={color}
        stroke-width="1.20367"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default CalendarIcon;
